export default {"src":"/_next/static/media/Alejandro-Cartagena4.fd8ca3f0.JPG","height":550,"width":368};